<script setup>
import {DsTable, DsTableRow, DsTableCell} from '@ds/vue2'
import translate from "@/filters/translate.filter"
 
const tableData = [
  {
    key: translate('goldkid-conditions-table-row-1:key'),
    value: translate('goldkid-conditions-table-row-1:value')
  },
  {
    key: translate('goldkid-conditions-table-row-2:key'),
    value: translate('goldkid-conditions-table-row-2:value')
  },
  {
    key: translate('goldkid-conditions-table-row-3:key'),
    value: translate('goldkid-conditions-table-row-3:value')
  },
  {
    key: translate('goldkid-conditions-table-row-4:key'),
    value: translate('goldkid-conditions-table-row-4:value')
  },
  {
    key: translate('goldkid-conditions-table-row-5:key'),
    value: translate('goldkid-conditions-table-row-5:value')
  },
  {
    key: translate('goldkid-conditions-table-row-6:key'),
    value: translate('goldkid-conditions-table-row-6:value')
  },
  {
    key: translate('goldkid-conditions-table-row-7:key'),
    value: translate('goldkid-conditions-table-row-7:value')
  },
  {
    key: translate('goldkid-conditions-table-row-8:key'),
    value: translate('goldkid-conditions-table-row-8:value')
  }
]
</script>

<template>
  <DsTable text-size="large">
    <DsTableRow v-for="(data, index) in tableData" :key="index">
        <DsTableCell>
          <template #caption>
            <span v-html="data.key" />
          </template>
        </DsTableCell>
        <DsTableCell>
          <span v-html="data.value" />
        </DsTableCell>
    </DsTableRow>
  </DsTable>
</template>